export const DATA_REFRESH_EVENT = "compliance-sage:data-refresh";

interface DataRefreshDetail {
  waitUntil: (refresh: Promise<unknown>) => void;
}

export async function refreshCurrentPageData(): Promise<void> {
  const refreshes: Promise<unknown>[] = [];
  const event = new CustomEvent<DataRefreshDetail>(DATA_REFRESH_EVENT, {
    detail: {
      waitUntil: (refresh) => {
        refreshes.push(refresh);
      },
    },
  });

  window.dispatchEvent(event);
  await Promise.allSettled(refreshes);
}
